import type { ScrollArea } from '@ophelos/ui/components/scroll-area';
import { useEffect, useRef, useState } from 'react';

/**
 * Hook to detect scroll position in a ScrollArea component
 * Returns a ref to attach to ScrollArea and a boolean indicating if scrolled
 */
export function useScrollDetection() {
  const [isScrolled, setIsScrolled] = useState<boolean>(false);
  const scrollAreaRef = useRef<React.ElementRef<typeof ScrollArea>>(null);

  useEffect(() => {
    const viewport = scrollAreaRef.current;
    if (!viewport) return;

    const handleScroll = () => {
      const scrollTop = viewport.scrollTop;
      if (scrollTop > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    // Check initial scroll position
    handleScroll();

    viewport.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      viewport.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return { scrollAreaRef, isScrolled };
}
